export default __webpack_public_path__ + "static/media/LAS0720.34I-37966_-22254_0.5a743773.jpg";